import ArrowBottom from "assets/svg/arrow-down-2.svg";
import { FC } from "react";

type Props = {
  title: string | JSX.Element;
  btnClass?: string | any;
  menu_class?: string | undefined;
  wrapper_class?: string | undefined;
  svg_class?: string | undefined;
  position?: "TOP" | "BOTTOM";
  isShowTitle?: boolean;
  titleClass?: string;
  isLeft?: boolean;
  Icon?:
    | React.FunctionComponent<React.SVGAttributes<SVGElement>>
    | boolean
    | any;
};

const DropDown: FC<Props> = ({
  title,
  svg_class,
  btnClass,
  menu_class,
  Icon,
  wrapper_class,
  titleClass,
  position = "BOTTOM",
  isShowTitle = true,
  isLeft = false,
  children,
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        // e.preventDefault();
      }}
      className={`z-50 flex items-center justify-center ${wrapper_class}`}
    >
      <div className="dropdown group relative z-50 inline-block h-full w-auto">
        <span className="h-full w-auto rounded-md shadow-sm">
          <button
            className={`focus:shadow-outline-blue peer flex h-full w-auto items-center justify-center gap-x-3 rounded-full border border-blue-550 bg-white px-5 py-2 text-xs font-medium text-blue-550 transition duration-150 ease-in-out focus-within:border-none focus-within:bg-blue-550/10 focus-within:shadow focus:outline-none active:text-gray-800 md:h-[34px] lg:h-[51px] lg:text-sm xl:text-base ${btnClass}`}
            type="button"
            aria-haspopup="true"
            aria-expanded="true"
            aria-controls="headlessui-menu-items-117"
          >
            {isShowTitle && <span className={titleClass}>{title}</span>}
            {Icon ? (
              <Icon className={svg_class} />
            ) : (
              <ArrowBottom
                className={`h-3 w-3 peer-focus:bg-white ${svg_class}`}
              />
            )}
          </button>
        </span>
        <div
          className={`dropdown-menu invisible absolute min-w-[11.1rem] origin-top-right translate-y-0 transform opacity-0 transition-all duration-300 group-hover:visible group-hover:opacity-100 
          ${isLeft ? "left-0" : "right-0"} 
          ${
            position == "TOP"
              ? "group-hover:-translate-y-[10.7rem] md:group-hover:-translate-y-[18.5rem]"
              : "group-hover:translate-x-0"
          }`}
          onMouseDown={(e) => e.preventDefault()}
        >
          <div
            className={` z-50 mt-0 origin-top-right rounded-md border border-gray-200 bg-white shadow-lg outline-none ${menu_class}`}
            aria-labelledby="headlessui-menu-button-1"
            id="headlessui-menu-items-117"
            role="menu"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
export default DropDown;
